import { AccountType, type User } from "@/services/user/userTypes";

export const isOurAccount = (user: User): boolean => {
  return user.type === AccountType.Common;
};

export function assertUserIsLoggedIn(user: User | undefined): asserts user is User {
  if (user === undefined) {
    throw new Error("User is not logged in.");
  }
}
